import NotificationCenter from '../features/notifications/NotificationCenter';

export default function PushNotificationsPage() {
  return (
    <div className="page">
      <header className="page-header">
        <div>
          <h1>Push Bildirimleri</h1>
          <p>Toplu mesajlar hazırlayın ve işlemsel bildirimleri otomatikleştirin.</p>
        </div>
      </header>
      <section className="page-section">
        <NotificationCenter />
      </section>
    </div>
  );
}
